.main-container {
  position: relative;
  box-sizing: border-box;
  height: 100%;
  background: var(--white-layout-302-level-1-elevation);
  padding: var(--vertical-widget-main-container-padding);
  color: var(--chart-300-icon-buttons);
  page-break-inside: avoid;

  &:active {
    #move-icon {
      visibility: visible;
    }
  }

  #close-button {
    position: absolute;
    top: var(--spacer);
    right: var(--spacer);
    width: auto;
    height: auto;
  }

  #move-icon {
    position: absolute;
    top: 0;
    left: 0;
    width: 80%;
    cursor: move;
  }
}

.widget-header {
  display: flex;
  align-items: center;
  gap: var(--spacer);
  padding-right: calc(var(--spacer) * 3);
  cursor: default;

  .title {
    line-height: calc(var(--spacer) * 4);
  }
}

.widget-title {
  padding: calc(var(--spacer) / 2 + 1px) 0;
  width: fit-content;
  display: contents;
  color: var(--main-titles-inputs-600);
}

.widget-footer {
  display: inline;
  position: absolute;
  bottom: 0;
  width: 100%;
}

#move-icon {
  visibility: hidden;
  height: auto;
}

#close-button {
  visibility: hidden;
}

:host([contentOrientation='vertical-flex']) {
  .main-container {
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
  }

  .widget-content {
    width: 100%;
    margin-top: auto;
    margin-bottom: auto;
  }
}

:host([contentOrientation='vertical']) {
  .main-container {
    display: flow-root;
  }
}

:host([contentOrientation='horizontal']) {
  .main-container {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    padding: var(--horizontal-widget-main-container-padding);
  }

  .widget-content {
    flex: 1;
    height: 100%;
  }
}

gz-icon-button[id='move-icon'] {
  --cursor-type: move;
}

:host([state='is-active']) {
  .has-action:hover {
    cursor: pointer;
    color: var(--blue-layout-400-primary);
  }
  height: 100%;
}

:host([state='is-loading']) {
  .widget-footer {
    display: none;
  }
  gz-select {
    display: none;
  }
}

.title-center {
  text-align: center;
  width: 100%;
  // this was added in order for the title to be perfectly centered (parent had a padding-right)
  padding-left: calc(var(--spacer) * 3);
}

:host([id='gz-executive-summary-inventory']) {
  .main-container {
    padding-top: 0;
    padding-bottom: 0;
  }
}
